import { jsx as _jsx } from "react/jsx-runtime";
import { colors, typography, spacing } from '@mehilainen/mds-tokens';
import { svgIconClasses } from '@mui/material';
// NOTE: Do not import these from lib root (src/index)! Will cause circular deps
import { AngleBottom } from '../../../icons';
const { baseTypography } = typography;
export const getThemeAccordion = (tokens) => {
    return {
        MuiAccordion: {
            defaultProps: {
                disableGutters: true,
                square: true,
            },
            styleOverrides: {
                root: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    borderBottom: '1px solid ' + colors.Gray300,
                    '&:before': {
                        display: 'none',
                    },
                },
            },
        },
        MuiAccordionSummary: {
            defaultProps: {
                expandIcon: _jsx(AngleBottom, {}),
            },
            styleOverrides: {
                root: {
                    padding: 0,
                    height: tokens.uiElementAccordion.height,
                    '&:hover': {
                        color: colors.Primary500,
                    },
                },
                expandIconWrapper: {
                    height: tokens.uiElementAccordion.iconSize,
                    width: tokens.uiElementAccordion.iconSize,
                    [`& > .${svgIconClasses.root}`]: {
                        fontSize: tokens.uiElementAccordion.iconSize,
                        color: colors.Primary500,
                    },
                },
                content: {
                    fontSize: tokens.uiElementAccordion.titleFontSize,
                    fontWeight: baseTypography.weight.Regular,
                    lineHeight: baseTypography.height.Large,
                    '&.Mui-expanded': {
                        fontWeight: typography.baseTypography.weight.Medium,
                    },
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    padding: `0 0 ${spacing[600].px} 0`,
                    fontSize: tokens.uiElementAccordion.contentDefaultFontSize,
                },
            },
        },
    };
};
